import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';

import { LOGOUT } from 'ConstComponents';
import {
    SelectState as SELECT_STATE,
    SelectDistrictByState as SELECT_DISTRICT_BY_STATE,
    AEPSRegistration as AEPS_REGISTRATION
} from 'Components/Api/MahagramAEPSAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import {
    Container,
    MenuItem,
    Grid,
    Paper,
    Button,
    CircularProgress,
    Box,
    TextField
} from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const MahagramRegistration = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [stateList, setStateList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [DisplayImage, setDisplayImage] = useState(false);
    const [IdentityProofImage, setIdentityProofImage] = useState('');
    const [AddressProofImage, setAddressProofImage] = useState('');
    const [ShopPhotoImage, setShopPhotoImage] = useState('');
    const [PassportPhotoImage, setPassportPhotoImage] = useState('');

    const [status, setStatus] = useState('PROCESS');
    const [Message, setMessage] = useState('');

    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);

    const selectStates = async () => {
        const response = await SELECT_STATE();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
        }

        var data = JSON.parse(response.data);
        setStateList(data);
    };

    const selectDistrict = async (StateID) => {
        if (
            StateID === null ||
            StateID === undefined ||
            StateID === 0 ||
            StateID === '0'
        )
            return;

        var requestObj = {
            StateID: StateID
        };
        var request = JSON.stringify(requestObj);

        const { isAuthorized, status, data } = await SELECT_DISTRICT_BY_STATE(
            request
        );

        if (!isAuthorized) LOGOUT();

        if (!status) setIsError(true);

        var districtData = JSON.parse(data);
        setDistrictList(districtData);
    };

    const [UserObj, setUserObj] = useState({
        FirstName: '',
        MiddelName: '',
        LastName: '',
        DateOfBirth: '',
        StateID: '',
        DistrictID: '',
        Block: '',
        City: '',
        Landmark: '',
        Location: '',
        Mohhalla: '',
        PinCode: '',
        ShopType: '',
        Qualification: '',
        Population: '',
        LocationType: '',
        IdentityProof: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },
        AddressProof: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },
        ShopPhoto: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },
        PassportPhoto: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        }
    });

    const OnStateChange = async (name, value, setFieldValue) => {
        var StateID = value;
        setFieldValue(name, value);
        selectDistrict(StateID);
    };

    useEffect(() => {
        selectStates();
    }, []);

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);
        setIsError(false);
        setResponseMessage('');

        var inputObj = {
            FirstName: values.FirstName,
            MiddelName: values.MiddelName,
            LastName: values.LastName,
            DateOfBirth: values.DateOfBirth,
            StateID: values.StateID,
            DistrictID: values.DistrictID,
            Block: '20',
            City: values.City,
            Landmark: values.Landmark,
            Location: values.Location,
            Mohhalla: values.Landmark,
            PinCode: values.PinCode,
            IdentityProof: values.IdentityProof,
            AddressProof: values.AddressProof,
            ShopPhoto: values.ShopPhoto,
            PassportPhoto: values.PassportPhoto,
            ShopType: values.ShopType,
            Qualification: values.Qualification,
            Population: values.Population,
            LocationType: values.LocationType
        };

        const { isAuthorized, status, data } = await AEPS_REGISTRATION(
            JSON.stringify(inputObj)
        );
        setLoading(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setSeverity('error');
            setResponseMessage(data);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(data);
            setIsAlertErrorOpen(true);
            return;
        }

        var dataInner = JSON.parse(data);
        setSeverity('success');
        setResponseMessage(dataInner.Message);
        setIsError(true);

        setSubmitting(false);

        resetForm(UserObj);

        history.push('/MAEPS');
    };

    const validationSchema = Yup.object({
        FirstName: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'first name'),

        MiddelName: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'middel name'),

        LastName: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'last name'),

        StateID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'state')
            .required(PLEASE_SELECT_VALID + 'state'),

        DistrictID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'district')
            .required(PLEASE_SELECT_VALID + 'district'),

        City: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'city'),

        Location: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'location'),

        Landmark: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'landmark'),

        ShopType: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'shoptype')
            .required(PLEASE_SELECT_VALID + 'shoptype'),

        Qualification: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'qualification')
            .required(PLEASE_SELECT_VALID + 'qualification'),
        Population: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'population')
            .required(PLEASE_SELECT_VALID + 'population'),

        LocationType: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'locationType')
            .required(PLEASE_SELECT_VALID + 'locationType')
    });

    const UploadForm = (formProps) => {
        return (
            <Form>
                <Paper style={{ padding: 8 }} className={classes.PaperStyle}>
                    <h2 className={classes.PaperHead_h2}>
                        Personal Details
                        <span className={classes.Require}>*</span>
                    </h2>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3}>
                                <MaterialTextField
                                    label="First Name"
                                    name="FirstName"
                                    type="text"
                                    title="First Name"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                <MaterialTextField
                                    label="Middel Name"
                                    name="MiddelName"
                                    type="text"
                                    title="Middel Name"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                <MaterialTextField
                                    label="Last Name"
                                    name="LastName"
                                    type="text"
                                    title="Last Name"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                <MaterialDatePickerField
                                    name="DateOfBirth"
                                    label="Date Of Birth"
                                    maxDate={new Date()}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <h2 className={classes.PaperHead_h2}>
                        Address
                        <span className={classes.Require}>*</span>
                    </h2>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="State"
                                    name="StateID"
                                    onCustomCallback={(name, value) => {
                                        OnStateChange(
                                            name,
                                            value,
                                            formProps.setFieldValue
                                        );
                                    }}
                                    title="State"
                                >
                                    <MenuItem key="0" value="0">
                                        Select State
                                    </MenuItem>
                                    {stateList.map(
                                        ({ StateID, StateName }, index) => (
                                            <MenuItem
                                                key={index}
                                                value={StateID}
                                            >
                                                {StateName}
                                            </MenuItem>
                                        )
                                    )}
                                </MaterialSelect>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="District"
                                    name="DistrictID"
                                    title="District"
                                >
                                    <MenuItem key="0" value="0">
                                        Select District
                                    </MenuItem>
                                    {districtList.map(
                                        (
                                            { DistrictID, DistrictName },
                                            index
                                        ) => (
                                            <MenuItem
                                                key={index}
                                                value={DistrictID}
                                            >
                                                {DistrictName}
                                            </MenuItem>
                                        )
                                    )}
                                </MaterialSelect>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialTextField
                                    label="City"
                                    name="City"
                                    type="text"
                                    icon="shop"
                                    title="City"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialTextField
                                    label="Landmark"
                                    name="Landmark"
                                    type="text"
                                    icon="shop"
                                    title="Landmark"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={9} lg={9}>
                                <MaterialTextField
                                    label="Location"
                                    name="Location"
                                    type="text"
                                    length={100}
                                    title="Location"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialNumberField
                                    label="Pin code"
                                    name="PinCode"
                                    type="text"
                                    length={6}
                                    title="Pin code"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <h2 className={classes.PaperHead_h2}>
                        Other Details
                        <span className={classes.Require}>*</span>
                    </h2>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="Shop Type"
                                    name="ShopType"
                                    title="Shop Type"
                                >
                                    <MenuItem key="0" value="0">
                                        Select ShopType
                                    </MenuItem>
                                    <MenuItem key="1" value="1">
                                        Kirana Shop
                                    </MenuItem>
                                    <MenuItem key="2" value="2">
                                        Mobile Shop
                                    </MenuItem>
                                    <MenuItem key="3" value="3">
                                        Copier Shop
                                    </MenuItem>
                                    <MenuItem key="4" value="4">
                                        Internet Cafe
                                    </MenuItem>
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="Qualification"
                                    name="Qualification"
                                    title="Qualification"
                                >
                                    <MenuItem key="0" value="0">
                                        Select Qualification
                                    </MenuItem>
                                    <MenuItem key="1" value="1">
                                        SSC
                                    </MenuItem>
                                    <MenuItem key="2" value="2">
                                        HSC
                                    </MenuItem>
                                    <MenuItem key="3" value="3">
                                        Graduate
                                    </MenuItem>
                                    <MenuItem key="4" value="4">
                                        Post Graduate
                                    </MenuItem>
                                    <MenuItem key="5" value="5">
                                        Diploma
                                    </MenuItem>
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="Area Population"
                                    name="Population"
                                    title="Population"
                                >
                                    <MenuItem key="0" value="0">
                                        Select Population
                                    </MenuItem>
                                    <MenuItem key="1" value="1">
                                        0 to 2000
                                    </MenuItem>
                                    <MenuItem key="2" value="2">
                                        2000 to 5000
                                    </MenuItem>
                                    <MenuItem key="3" value="3">
                                        5000 to 10000
                                    </MenuItem>
                                    <MenuItem key="4" value="4">
                                        10000 to 50000
                                    </MenuItem>
                                    <MenuItem key="5" value="5">
                                        50000 to 100000
                                    </MenuItem>
                                    <MenuItem key="6" value="6">
                                        100000+
                                    </MenuItem>
                                </MaterialSelect>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="Location Type"
                                    name="LocationType"
                                    title="Location Type"
                                >
                                    <MenuItem key="0" value="0">
                                        Select Location Type
                                    </MenuItem>
                                    <MenuItem key="1" value="1">
                                        Rural
                                    </MenuItem>
                                    <MenuItem key="2" value="2">
                                        Urban
                                    </MenuItem>
                                    <MenuItem key="3" value="3">
                                        Metro Semi Urban
                                    </MenuItem>
                                </MaterialSelect>
                            </Grid>
                        </Grid>
                    </Grid>
                    <h2 className={classes.PaperHead_h2}>
                        KYC Details
                        <span className={classes.Require}>*</span>
                    </h2>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <label style={{ margin: '10px' }}>
                                    Identity Proof Image
                                </label>
                                <TextField
                                    id="file"
                                    name="IdentityProof"
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setIdentityProofImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'IdentityProof.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'IdentityProof.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'IdentityProof.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'IdentityProof.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                        setDisplayImage(true);
                                    }}
                                />
                            </Grid>
                            {DisplayImage ? (
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <img
                                        name="IdentityProofImage"
                                        src={IdentityProofImage}
                                        height={100}
                                        width={300}
                                        alt={IdentityProofImage}
                                    />
                                </Grid>
                            ) : null}

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <label style={{ margin: '10px' }}>
                                    Address Proof Image
                                </label>
                                <TextField
                                    id="file"
                                    name="AddressProof"
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setAddressProofImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'AddressProof.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'AddressProof.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'AddressProof.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'AddressProof.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                        setDisplayImage(true);
                                    }}
                                />
                            </Grid>
                            {DisplayImage ? (
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <img
                                        name="AddressProofImage"
                                        src={AddressProofImage}
                                        height={100}
                                        width={300}
                                        alt={AddressProofImage}
                                    />
                                </Grid>
                            ) : null}

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <label style={{ margin: '10px' }}>
                                    Shop Photo Image
                                </label>
                                <TextField
                                    id="file"
                                    name="ShopPhoto"
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setShopPhotoImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'ShopPhoto.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'ShopPhoto.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'ShopPhoto.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'ShopPhoto.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                        setDisplayImage(true);
                                    }}
                                />
                            </Grid>
                            {DisplayImage ? (
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <img
                                        name="ShopPhotoImage"
                                        src={ShopPhotoImage}
                                        height={100}
                                        width={300}
                                        alt={ShopPhotoImage}
                                    />
                                </Grid>
                            ) : null}

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <label style={{ margin: '10px' }}>
                                    Passport Photo Image
                                </label>
                                <TextField
                                    id="file"
                                    name="PassportPhoto"
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setPassportPhotoImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'PassportPhoto.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'PassportPhoto.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'PassportPhoto.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'PassportPhoto.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                        setDisplayImage(true);
                                    }}
                                />
                            </Grid>
                            {DisplayImage ? (
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <img
                                        name="PassportPhotoImage"
                                        src={PassportPhotoImage}
                                        height={100}
                                        width={300}
                                        alt={PassportPhotoImage}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>
                    </Grid>
                </Paper>

                <Grid className={classes.footerGrid}>
                    <Box className={classes.flexReverse}>
                        <div className={classes.SubmitWrapper}>
                            <Button
                                type="submit"
                                title="Register"
                                className={classes.CustomPrimaryButtonStyle}
                                disabled={loading}
                            >
                                Register
                            </Button>
                            {loading && (
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </div>
                        <Button
                            type="reset"
                            title="Reset"
                            className={classes.CustomDangerButtonStyle}
                        >
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Form>
        );
    };
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={UserObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={UserObj}
            >
                {UploadForm}
            </Formik>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
